import specialtyStore from './specialty_store.vue';

export default specialtyStore;
